// React
import { Fragment } from "react";

// Styled Components
import styled from "styled-components";

// Components
import RoadmapItem from "./RoadmapItem/RoadmapItem";

const Roadmap = () => {
  return (
    <Fragment>
      <Wrapper>
        <p className="header">Road Map</p>

        <div className="line-wrapper">
          <div className="roadmap-line"></div>
        </div>

        <div className="items">
          <RoadmapItem
            align={"left"}
            img={
              "https://cdn.discordapp.com/attachments/896285560094748713/898139094339710976/1.jpg"
            }
            title={"1. PRE LAUNCH"}
            info={`Build a whitelist discord community through invite only. No promotion or shilling`}
          />
          <RoadmapItem
            align={"right"}
            img={
              "https://cdn.discordapp.com/attachments/896285560094748713/898139188287918091/2.jpg"
            }
            title={"2. SEASON 1 STARTS"}
            info={`Players start collecting and generating shoeuzi nfts. Season 1 will run until March 5th. After then players who have 10+ nfts in their wallet are eligible for real life mint`}
            rotateImage={true}
          />
          <RoadmapItem
            align={"left"}
            img={
              "https://cdn.discordapp.com/attachments/896285560094748713/898139200916979712/4.jpg"
            }
            title={"3. ACCELERATE GAME BUILD OUT"}
            info={`Using the money from the mint we can accelerate our game build and secure the land in the metaverse.`}
          />
          <RoadmapItem
            align={"right"}
            img={
              "https://cdn.discordapp.com/attachments/896285560094748713/898162595188604998/season2.jpg"
            }
            title={"4. SEASON 2"}
            info={`The season 2 game starts with the mint sales we will start our expansion into the metaverse
            `}
          />

          <RoadmapItem
            align={"left"}
            img={
              "https://cdn.discordapp.com/attachments/896285560094748713/898139209846648832/3.jpg"
            }
            title={"4. METAVERSE EXPANSION"}
            info={`shoeuzi will start creating a chain of hype stores in the metaverse. These stores will be where you come to buy streetwearables and urban art in the metaverse`}
          />
        </div>
      </Wrapper>
    </Fragment>
  );
};

export default Roadmap;

const Wrapper = styled.div`
  width: 100%;
  color: #fff;
  padding: 0 25px;
  padding-top: 150px;

  background-color: #000;

  .header {
    text-align: center;
    font-family: "Pixeltype";
    font-weight: 200;

    line-height: 48px;

    font-style: normal;
    font-size: 2rem;

    padding-bottom: 50px;
  }

  .line-wrapper {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;

    width: 100%;
    height: 100%;
    z-index: 1000;

    //
    @media only screen and (max-width: 810px) {
      width: 500px;
      margin: 0 auto;
    }

    @media only screen and (max-width: 580px) {
      width: 100%;
    }
    //
  }

  .roadmap-line {
    width: 5px;

    border-radius: 20px;
    background-color: #fff;
    z-index: 1000;

    //
    height: 1300px;
    @media only screen and (max-width: 810px) {
      height: 1150px;
    }
    @media only screen and (max-width: 580px) {
      height: 1250px;
    }
    @media only screen and (max-width: 450px) {
      height: 1350px;
    }
    @media only screen and (max-width: 410px) {
      height: 1400px;
    }
    @media only screen and (max-width: 390px) {
      height: 1500px;
    }
    //

    position: absolute;
    left: 50%;
    transform: translateX(-50%);

    //
    @media only screen and (max-width: 810px) {
      left: 91px;
    }

    @media only screen and (max-width: 580px) {
      left: 130px;
    }
    //
  }

  .items {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 100px;
  }
`;
